<template>
  <!-- 险种介绍 -->

  <div class="InIntroduced">
    <div v-if="hasInsure" class="insure-info-wrapper" v-html="insureHtml"></div>
    <div v-else class="insure-info-nodata">
      <img src="~@/assets/images/insuranceImg/nodataImg.png" alt="图片" />
      <p>暂无可购买的险种</p>
    </div>

    <!-- 底部 绝对定位-->
    <div v-if="hasInsure" class="footer-box">
      <el-button @click="buyInsure" type="primary" size="default" class="butGo">
        立即投保
      </el-button>
    </div>
  </div>
</template>

<script>
import { getInsureInfo } from "@/api/request/snkd.produce";
import { SessionStorage } from "@/utils/storage";

export default {
  name: "IntroducedJs",
  props: {
    handleTitle: String,
    insuranceId: Number,
  },
  data() {
    return {
      insureHtml: "",
      hasInsure: true,
      list: [],
    };
  },
  methods: {
    // 立即投保 buyInsure
    async buyInsure() {
      this.$emit("buyInsure");
    },

    async getInsureInfomation() {
      this.insureInfo = SessionStorage.get("insureInfo");
      const res = await getInsureInfo({
        enableFlag: 1,
        pageNo: 1,
        pageSize: 100,
      });
      if (res.obj.list && res.obj.list.length) {
        this.hasInsure = true;
        this.list = res.obj.list;
        this.insureHtml = res.obj.list.find((item) => {
          return item.id === this.insureInfo.id;
        }).remark;
        this.$emit(
          "update:handleTitle",
          res.obj.list.find((item) => {
            return item.id === this.insureInfo.id;
          }).insureName
        );
      } else {
        this.$emit("update:handleTitle", "农业保险");
        this.hasInsure = false;
      }
    },
  },
  mounted() {
    this.getInsureInfomation();
  },
};
</script>

<style lang="scss" scoped>
.InIntroduced {
  width: 1200px;
  margin: 0 auto;
  height: 100%;
  background: #fff;

  // 底部
  .footer-box {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 1200px;
    height: 68px;
    background: #ffffff;
    box-shadow: 0px -4px 20px rgba(0, 0, 0, 0.04);
  }
  .butGo {
    position: absolute;
    left: 50%;
    bottom: 50%;
    transform: translate(-50%, 50%);
  }
  ::v-deep .el-button {
    width: 136px;
  }
}
.insure-info-nodata {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    white-space: nowrap;
    margin-top: 20px;
  }
}
.insure-info-wrapper {
  text-align: left;
  font-size: 14px;
  line-height: 32px;
  color: #333;
  padding-bottom: 56px;

  ::v-deep {
    * {
      padding: 0;
      margin: 0;
      box-sizing: border-box;
    }
    i {
      font-style: italic;
      font-weight: normal;
      * {
        font-style: italic;
      }
    }
    b {
      font-weight: bold;
      * {
        font-weight: bold;
      }
    }
    table {
      border-top: 1px solid #ccc;
      border-left: 1px solid #ccc;
    }
    table td,
    table th {
      border-bottom: 1px solid #ccc;
      border-right: 1px solid #ccc;
      padding: 3px 5px;
    }
    table th {
      text-align: center;
      border-bottom: 2px solid #ccc;
      background-color: #f1f1f1;
    }

    /* blockquote 样式 */
    blockquote {
      display: block;
      border-left: 8px solid #d0e5f2;
      padding: 5px 10px;
      margin: 10px 0;
      line-height: 1.4;
      font-size: 100%;
      background-color: #f1f1f1;
    }

    /* code 样式 */
    code {
      display: inline-block;
      *display: inline;
      *zoom: 1;
      background-color: #f1f1f1;
      border-radius: 3px;
      padding: 3px 5px;
      margin: 0 3px;
    }
    pre code {
      display: block;
    }

    /* ul ol 样式 */
    ul,
    ol {
      margin: 10px 0 10px 20px;
    }

    h1 {
      font-size: 32px !important;
    }
    h2 {
      font-size: 24px !important;
    }
    h3 {
      font-size: 18.72px !important;
    }
    h4 {
      font-size: 16px !important;
    }
    h5 {
      font-size: 13.28px !important;
    }
    p {
      font-size: 16px !important;
    }
    .eleImg {
      cursor: pointer;
      display: inline-block;
      font-size: 18px;
      padding: 0 3px;
    }
    h1,
    h2,
    h3,
    h4,
    h5 {
      font-weight: bold;
      line-height: 1.5;
      margin: 10px 0;
      * {
        font-weight: bold;
      }
    }
    p,
    table,
    pre {
      // margin: 10px 0;
      line-height: 1.5;
    }
    table {
      table-layout: fixed;
      th,
      td {
        height: 30px;
        border-width: 1px;
      }
    }
    ul {
      list-style: disc inside;
      li {
        list-style: disc;
      }
    }
    ol {
      li {
        list-style: decimal;
      }
      list-style: decimal inside;
    }
  }
}
</style>
